var zo = zo || {};


// Showing/hiding header on scroll
//-----------------------------------------------------------------
zo.toggleHeader = function() {

    var $header = $('.header'),
        headerHeight = $header.outerHeight(),
        lastScrollTop = 0,
        offset = 5,
        didScroll;

    if (!$header.length) {
        return;
    }

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 150);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= offset) {
            return;
        }

        if (st > lastScrollTop && st > headerHeight){
            // Scroll down
            $header.removeClass('nav_down').addClass('nav_up');
            $('.sticky').css('top', '10' + 'px');
        }
        else if (st + $(window).height() < $(document).height()) {
            // Scroll up
            $header.removeClass('nav_up').addClass('nav_down');
            $('.sticky').css('top', '20' + 'px');
        }
        
        if ($(window).scrollTop() <= 10) {
            $header.removeClass('nav_down nav_up');
            $('.sticky').removeAttr('style');
        }

        lastScrollTop = st;
    }

};



zo.toggleSearch = function() {

    var $toggleSearch = $('.js_toggleSearch'),
        $closeSearch = $('.js_closeSearch'),
        $searchPopup = $('.search_box');

    if (!$toggleSearch.length) {
        return;
    }

    $toggleSearch.on('click', function(e) {
        e.preventDefault();

        $searchPopup.addClass('search_box--visible');
        $('body').addClass('locked');
        
        setTimeout(function(){
            $('.search_box__input').focus();
        }, 400);
    });


    $('.search_box').on('click', function(e) {
        $searchPopup.removeClass('search_box--visible');
        $('body').removeClass('locked');
    });
    $(".search_box__input, .search_box__submit").click(function(e){
        e.stopPropagation();
    });

};

$(document).ready(function (){
    zo.toggleHeader();
    zo.toggleSearch();
});